/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsGender
 */
export interface MelcoModelsGender {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsGender
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsGender
     */
    text?: string | null;
}

export function MelcoModelsGenderFromJSON(json: any): MelcoModelsGender {
    return MelcoModelsGenderFromJSONTyped(json, false);
}

export function MelcoModelsGenderFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGender {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function MelcoModelsGenderToJSON(value?: MelcoModelsGender | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'text': value.text,
    };
}


